// @ts-nocheck
import { Flex } from '@mantine/core';
import React, { FC, useContext, useEffect, useState } from 'react';
import * as Enums from '@/utils/enums';
import SubscriptionContext from '@/utils/subscription-context';
import { useRouter } from 'next/router';
import billingService from '@/services/billing-service';
import helper from '@/utils/helper';
import SignatureTemplatesTable from '@/PageComponents/Table/Component Tables/SignatureTemplatesTable';
import SettingsMenu from '@/components/settings/menu';
import { createFileRoute } from '@tanstack/react-router'



const SignatureTemplateList: FC<{}> = ({ }: any) => {

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None)
    const subscriptionContext = useContext(SubscriptionContext);
    const router = useRouter();

    const getAccessStatus = async () => {
        const [subscriptionInfo, message] = await billingService.getSubcriptionInfo(subscriptionContext)
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus)
        }
    };

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            console.log('no access', accessStatus, Enums.AccessStatus)
            helper.nextRouter(router.replace, '/');
        }
    }, [accessStatus]);

    return (<>

        {/*<Box
            mt={'sm'}
            px={'md'}
            mb={0}
            pb={0}
            style={(theme) => ({ borderBottom: `var(--mantine-color-gray-2) 2px solid` })}
        >
            <Box my={'md'}>
                <Breadcrumbs
                    crumbs={[
                        { text: 'Settings', link: '', suppressLink: true },
                        { text: 'Signature Templates', link: '/settings/signaturetemplate/list' },
                    ]}
                />
            </Box>
        </Box>*/}

        <div className="settings-container">
            <Flex>
                <SettingsMenu urlPath={router.asPath}/>
                <div className="settings-card">
                    <SignatureTemplatesTable/>
                </div>
            </Flex>
        </div>

        <style jsx>{`

        `}</style>
    </>);
};

export default SignatureTemplateList;

export const Route = createFileRoute('/_authenticated/settings/signaturetemplate/list')({ component: SignatureTemplateList })
